module.exports = __webpack_public_path__ + "fonts/Poppins-300-latin-ext5.b0bb003.woff2";